import { useEffect, useState } from 'react';
import background from '../../assets/img/fondo2.jpg';

export default function SiggerPrivacyPolicy() {
    const [bkgImage, setBkgImage] = useState(background);

    useEffect(() => {
        setBkgImage(background);
    }, []);

    return (
        <div className="relative min-h-screen mx-5 mb-10" id="privacy-policy">
            <div className="fixed inset-0">
                <img
                    src={bkgImage}
                    alt="Background"
                    className="object-cover w-full h-full"
                />
                <div className="fixed inset-0 bg-black opacity-40"></div>
            </div>
            <div className="relative z-10 max-w-4xl p-6 mx-auto mt-10 text-gray-800 bg-white rounded-lg shadow-lg sm:p-12">
                <h1 className="mb-4 text-4xl font-bold text-center text-gray-900">
                    Política de Privacidad de Sigger
                </h1>
                <p className="mb-8 text-sm text-center text-gray-500">
                    Última actualización: 11 de septiembre de 2024
                </p>

                <p className="mb-6 leading-relaxed text-justify">
                    Esta Política de Privacidad describe nuestras políticas y procedimientos sobre la recopilación, uso y divulgación de su información cuando utiliza el servicio e informa sobre sus derechos de privacidad y cómo la ley lo protege.
                </p>

                <p className="mb-8 leading-relaxed text-justify">
                    Usamos sus datos personales para proporcionar y mejorar el servicio. Al utilizar el servicio, usted acepta la recopilación y el uso de la información de acuerdo con esta Política de Privacidad. Esta política ha sido creada con la ayuda de un generador de políticas de privacidad gratuito.
                </p>

                <h2 className="mb-4 text-2xl font-semibold">
                    Interpretación y Definiciones
                </h2>

                <h3 className="mb-2 text-xl font-medium">Interpretación</h3>
                <p className="mb-6 leading-relaxed text-justify">
                    Las palabras cuya letra inicial está en mayúscula tienen significados definidos en las siguientes condiciones. Las siguientes definiciones tendrán el mismo significado, independientemente de si aparecen en singular o en plural.
                </p>

                <h3 className="mb-2 text-xl font-medium">Definiciones</h3>
                <ul className="mb-8 space-y-2 text-justify list-disc list-inside">
                    <li>
                        <strong>Cuenta</strong> significa una cuenta única creada para que usted acceda a nuestro servicio o a partes de nuestro servicio.
                    </li>
                    <li>
                        <strong>Afiliado</strong> significa una entidad que controla, es controlada por, o está bajo el control común de una parte.
                    </li>
                    <li>
                        <strong>Aplicación</strong> se refiere a Sigger, el programa de software proporcionado por la empresa.
                    </li>
                    <li>
                        <strong>Compañía</strong> (referido como "la Compañía", "Nosotros", "Nos" o "Nuestro" en este Acuerdo) se refiere a Sigger.
                    </li>
                    <li><strong>País</strong> se refiere a: Chile.</li>
                    <li>
                        <strong>Dispositivo</strong> significa cualquier dispositivo que pueda acceder al servicio, como una computadora, un teléfono móvil o una tableta digital.
                    </li>
                    <li>
                        <strong>Datos Personales</strong> son cualquier información que se relacione con una persona identificada o identificable.
                    </li>
                    <li><strong>Servicio</strong> se refiere a la aplicación.</li>
                    <li>
                        <strong>Proveedor de servicios</strong> significa cualquier persona física o jurídica que procese los datos en nombre de la Compañía.
                    </li>
                    <li>
                        <strong>Datos de uso</strong> se refiere a los datos recopilados automáticamente, ya sea generados por el uso del servicio o de la infraestructura del servicio.
                    </li>
                    <li>
                        <strong>Usted</strong> significa la persona que accede o utiliza el servicio, o la empresa u otra entidad legal en nombre de la cual dicha persona accede o utiliza el servicio, según corresponda.
                    </li>
                </ul>

                <h2 className="mb-4 text-2xl font-semibold">
                    Recopilación y Uso de sus Datos Personales
                </h2>

                <h3 className="mb-2 text-xl font-medium">Tipos de Datos Recopilados</h3>

                <h4 className="mb-2 text-lg font-semibold">Datos Personales</h4>
                <p className="mb-6 leading-relaxed text-justify">
                    Mientras utiliza nuestro servicio, podemos pedirle que nos proporcione cierta información de identificación personal que se puede usar para contactarlo o identificarlo. La información de identificación personal puede incluir, entre otros:
                </p>
                <ul className="mb-8 space-y-2 list-disc list-inside">
                    <li>Correo electrónico</li>
                    <li>Nombre y apellido</li>
                    <li>Datos de uso</li>
                </ul>

                <h4 className="mb-2 text-lg font-semibold">Datos de Uso</h4>
                <p className="mb-8 leading-relaxed text-justify">
                    Los datos de uso se recopilan automáticamente cuando se utiliza el servicio e incluyen información como la dirección IP de su dispositivo, tipo de navegador, versión, páginas visitadas, fecha y hora, entre otros.
                </p>

                <h3 className="mb-2 text-xl font-medium">Uso de sus Datos Personales</h3>
                <p className="mb-6 leading-relaxed text-justify">
                    La Compañía puede usar los datos personales para los siguientes fines:
                </p>
                <ul className="mb-8 space-y-2 text-justify list-disc list-inside">
                    <li>
                        <strong>Para proporcionar y mantener nuestro servicio</strong>, incluyendo el monitoreo de su uso.
                    </li>
                    <li><strong>Para gestionar su cuenta</strong> y su registro.</li>
                    <li>
                        <strong>Para la ejecución de un contrato</strong> relacionado con productos o servicios comprados a través del servicio.
                    </li>
                    <li>
                        <strong>Para contactarlo</strong> por correo electrónico, teléfono u otros medios respecto a actualizaciones.
                    </li>
                    <li><strong>Para gestionar sus solicitudes</strong> y atender sus consultas.</li>
                    <li>
                        <strong>Para transferencias comerciales</strong>, como en fusiones o adquisiciones.
                    </li>
                    <li>
                        <strong>Para otros propósitos</strong> como análisis de datos y mejora del servicio.
                    </li>
                </ul>

                <h2 className="mb-4 text-2xl font-semibold">
                    Retención de sus Datos Personales
                </h2>
                <p className="mb-8 leading-relaxed text-justify">
                    Conservaremos sus datos personales solo durante el tiempo necesario para cumplir los fines establecidos en esta política. Los datos de uso se conservan generalmente por un período más corto.
                </p>

                <h2 className="mb-4 text-2xl font-semibold">
                    Seguridad de sus Datos Personales
                </h2>
                <p className="mb-8 leading-relaxed text-justify">
                    Nos esforzamos por utilizar medios comercialmente aceptables para proteger sus datos personales, pero ningún método de transmisión o almacenamiento es 100% seguro.
                </p>

                <h2 className="mb-4 text-2xl font-semibold">Privacidad de los Niños</h2>
                <p className="mb-8 leading-relaxed text-justify">
                    Nuestro servicio no está dirigido a menores de 13 años, y no recopilamos datos de menores de 13 años sin el consentimiento de los padres.
                </p>

                <h2 className="mb-4 text-2xl font-semibold">Cambios en esta Política de Privacidad</h2>
                <p className="mb-8 leading-relaxed text-justify">
                    Podemos actualizar nuestra política de privacidad de vez en cuando y le notificaremos los cambios por correo electrónico o mediante un aviso destacado.
                </p>

                <h2 className="mb-4 text-2xl font-semibold">Contáctenos</h2>
                <p className="mb-8 leading-relaxed text-justify">
                    Si tiene alguna pregunta, puede contactarnos por correo electrónico en <a href="mailto:fortiz@advise.cl" className="text-blue-600 underline">contacto@advise.cl</a>.
                </p>
            </div>
        </div>
    );
}
